
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://gjnsnmjlnnisvhdgzaje.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdqbnNubWpsbm5pc3ZoZGd6YWplIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMwODUwNjksImV4cCI6MjA1ODY2MTA2OX0.tWxZ7DDcCPgFETpFRV1LDWZaAhNbW7KrNx8nLkthF4U";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL, 
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      storage: localStorage,
      autoRefreshToken: true,
      persistSession: true,
    }
  }
);
